module.exports = __webpack_public_path__ + "static/media/gianluca_prestianni.71da9d9f.jpg";